import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';
import MuiAppBar from '@mui/material/AppBar';
import { IOpenMainProps } from '../../../interfaces/IUtils';

// Icons
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { clearStorage } from '../../../utils/storage';
import { useAppDispatch } from '../../../store';
import { removeToken } from '../../../store/feature/reducer/userReducer';

const drawerWidth = 320;
const Navbar = ({ open, setOpen }: IOpenMainProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];
  const handleDrawerOpen = () => { setOpen(true); };
  const [offset, setOffset] = useState(0);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const { pathname } = useLocation();
  const param = useParams();
  const breadcrumb: any = [{ label: 'Dashboard', href: '/' }];


  // REGION: BREADCRUMB NON DYMANIC
  
  if (pathname === '/product-list') {
    breadcrumb.push({ label: 'Product List', href: '/product-list' });
  } else if (pathname === '/product-list/create') {
    breadcrumb.push({ label: 'Product List', href: '/product-list' });
    breadcrumb.push({ label: 'Create Product ', href: '/product-list/create' });
  } else if (pathname === `/product-list/edit/${param.id}`) {
    breadcrumb.push({ label: 'Product List', href: '/product-list' });
    breadcrumb.push({ label: 'Update Product ', href: `/product-list/edit/${param.id}` });
  } else if (pathname === `/product-list/detail/${param.id}`) {
    breadcrumb.push({ label: 'Product List', href: '/product-list' });
    breadcrumb.push({ label: 'Detail Product ', href: `/product-list/detail/${param.id}` });
  }
  
  else if (pathname === '/pricing-config') {
    breadcrumb.push({ label: 'Pricing Config', href: '/pricing-config' });
  } else if (pathname === '/pricing-config/create') {
    breadcrumb.push({ label: 'Pricing Config', href: '/pricing-config' });
    breadcrumb.push({ label: 'Create Pricing ', href: '/pricing-config/create' });
  } else if (pathname === `/pricing-config/edit/${param.id}`) {
    breadcrumb.push({ label: 'Pricing Config', href: '/pricing-config' });
    breadcrumb.push({ label: 'Update Pricing ', href: `/pricing-config/edit/${param.id}` });
  } else if (pathname === `/pricing-config/detail/${param.id}`) {
    breadcrumb.push({ label: 'Pricing Config', href: '/pricing-config' });
    breadcrumb.push({ label: 'Detail Pricing ', href: `/pricing-config/detail/${param.id}` });
  }

  else if (pathname === '/company-list') {
    breadcrumb.push({ label: 'Company List', href: '/company-list' });
  } else if (pathname === '/company-list/create') {
    breadcrumb.push({ label: 'Company List', href: '/company-list' });
    breadcrumb.push({ label: 'Create Company ', href: '/company-list/create' });
  } else if (pathname === `/company-list/edit/${param.id}`) {
    breadcrumb.push({ label: 'Company List', href: '/company-list' });
    breadcrumb.push({ label: 'Update Company ', href: `/company-list/edit/${param.id}` });
  } else if (pathname === `/company-list/detail/${param.id}`) {
    breadcrumb.push({ label: 'Company List', href: '/company-list' });
    breadcrumb.push({ label: 'Detail Company ', href: `/company-list/detail/${param.id}` });
  }
  
  else if (pathname === '/billing-invoice') {
    breadcrumb.push({ label: 'Billing Invoice', href: '/billing-invoice' });
  } else if (pathname === '/billing-invoice/create') {
    breadcrumb.push({ label: 'Billing Invoice', href: '/billing-invoice' });
    breadcrumb.push({ label: 'Create Billing ', href: '/billing-invoice/create' });
  } else if (pathname === `/billing-invoice/edit/${param.id}`) {
    breadcrumb.push({ label: 'Billing Invoice', href: '/billing-invoice' });
    breadcrumb.push({ label: 'Update Billing ', href: `/billing-invoice/edit/${param.id}` });
  } else if (pathname === `/billing-invoice/detail/${param.id}`) {
    breadcrumb.push({ label: 'Billing Invoice', href: '/billing-invoice' });
    breadcrumb.push({ label: 'Detail Billing ', href: `/billing-invoice/detail/${param.id}` });
  }

  else if (pathname === '/user-admin') {
    breadcrumb.push({ label: 'User Admin', href: '/user-admin' });
  } else if (pathname === '/user-admin/create') {
    breadcrumb.push({ label: 'User Admin', href: '/user-admin' });
    breadcrumb.push({ label: 'Create User Admin ', href: '/user-admin/create' });
  } else if (pathname === `/user-admin/edit/${param.id}`) {
    breadcrumb.push({ label: 'User Admin', href: '/user-admin' });
    breadcrumb.push({ label: 'Update User Admin ', href: `/user-admin/edit/${param.id}` });
  } else if (pathname === `/user-admin/detail/${param.id}`) {
    breadcrumb.push({ label: 'User Admin', href: '/user-admin' });
    breadcrumb.push({ label: 'Detail User Admin ', href: `/user-admin/detail/${param.id}` });
  } else if (pathname === `/user-admin/update-password/${param.id}`) {
    breadcrumb.push({ label: 'User Admin', href: '/user-admin' });
    breadcrumb.push({ label: 'Update Password', href: `/user-admin/update-password/${param.id}` });
  }

  useEffect(() => {
      const onScroll = () => setOffset(window.pageYOffset);
      window.removeEventListener('scroll', onScroll);
      window.addEventListener('scroll', onScroll, { passive: true });
      return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleButton = (setting: any) => {
    if (setting === 'Logout') {
      dispatch(removeToken());
      navigate('/login', { replace: true });
      clearStorage();
    }
  };

  return (
    <MuiAppBar
      position="fixed"
      sx={{
        display: 'flex',
        background: 'transparent',
        // background: 'yellow',
        boxShadow: 'none',
        // backgroundColor: '#B3c100',
        alignItems: 'space-between',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
          marginLeft: drawerWidth,
          width: `calc(100% - ${drawerWidth}px)`,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
      }}
    >
      <Toolbar sx={{ borderRadius: 'none', paddingLeft: 0 }} variant="dense">
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginRight: 3.7,
            ...(open && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box
          sx={{
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'flex-end',
            display: 'flex',
          }}
        >
        
        {
          offset <= 30 &&
          <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            backgroundColor:'transparent',
            flex:1,
            marginTop:'12px',
            cursor: 'pointer'
            }}
          >
            {breadcrumb.map((item: any, index: Number) => {
              return index != breadcrumb.length-1 ? (
                <Link
                  key={item.label}
                  onClick={() => navigate(item.href)}
                  underline="hover">
                  {item.label}
                </Link>
              ) : (
                <Typography key={item.label} color="textPrimary">
                  {item.label}
                </Typography>
              )
            })}
          </Breadcrumbs>
        }

          <Tooltip title="Open settings">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar
                alt="Remy Sharp"
                src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              />
            </IconButton>
          </Tooltip>

          <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) => (
              <MenuItem key={setting} onClick={handleCloseUserMenu}>
                {/* <Typography textAlign="center">{setting}</Typography> */}
                <Button onClick={() => handleButton(setting)} sx={{width: '100%', justifyContent: "flex-start", textTransform: "none" , paddingX: '12px'}}>{setting}</Button>
              </MenuItem>
            ))}
          </Menu>

        </Box>
        {/* <Typography variant="h6" noWrap component="div">
            Mini variant drawer */}
        {/* </Typography> */}
        {/* <Navbar /> */}
      </Toolbar>
    </MuiAppBar>
  );
};

export default Navbar;
